import React from 'react';
import { Button, Modal, Space, Spin, Table, TableProps } from 'antd';
import { Link } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { makesList } from '../../../../../../API/TT_ELD/Users/make_moddel';
import { calcOrder } from '../../../../../components/core/calcOrder';
import { TableParams } from '../../../../../../Utils/TableTypes';

const { confirm } = Modal;

type numStr = string | number;

interface makeSource {
  no: numStr;
  id: numStr;
  name: string;
  createdAt: string;
  make: numStr;
  makeId: numStr;
  action: { id: numStr };
  key: React.Key;
}

const MakeTable = ({
  make = [],
  total = 0,
  isLoading,
  isFetching,
  refetch,
  handleTableChange,
  tableParams,
}: {
  make: Array<any> | undefined;
  total: number | undefined;
  isLoading: boolean | undefined;
  isFetching: boolean;
  refetch(): void;
  handleTableChange: TableProps<any>['onChange'];
  tableParams: TableParams;
}) => {
  const column: object[] = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Makes',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Created at',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      render: ({ id }: { id: string | undefined }) => {
        const showConfirm = () => {
          confirm({
            title: 'Approval',
            icon: <ExclamationCircleFilled rev={undefined} />,
            content: 'Do you want to delete this make ?',
            onOk: async () => {
              return new Promise(async (resolve, reject) => {
                setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                makesList.makePatch(id, { isActive: false });
                refetch();
              }).catch(() => {
                setTimeout(() => {
                  refetch();
                });
              });
            },
            onCancel() {},
          });
        };
        return (
          <Space>
            <Link to={`${id}`}>
              <Button>Edit</Button>
            </Link>
            {/*<Button  onClick={showConfirm}>*/}
            {/*    Delete*/}
            {/*</Button>*/}
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      <Spin size="large" spinning={isLoading || isFetching}>
        <Table
          style={{ margin: '15px 0 0 0' }}
          onChange={handleTableChange}
          dataSource={make?.map((u: any, i: number): makeSource => {
            const obj: makeSource = {
              no: calcOrder(tableParams.pagination?.current ?? 1, 10, i),
              id: u.id,
              name: u?.name,
              createdAt: u?.createdAt,
              make: u.make?.name,
              makeId: u.makeId,
              action: { id: u.id },
              key: u.id,
            };
            return obj;
          })}
          columns={column}
          pagination={{
            total: total,
            current: tableParams.pagination?.current,
            showSizeChanger: false,
          }}
          scroll={{ x: 'max-content' }}
        />
      </Spin>
    </div>
  );
};

export default MakeTable;
